import React, { useContext } from 'react'
import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

import PageWrapper from 'components/PageWrapper/PageWrapper'
import ListView, { fragment } from 'components/ListView/ListView'
import { PageTitle } from 'components/Elements/index'
import { LoadingSpinnerFullscreen } from 'components/Spinner/Spinner'
import TokenContext from 'helpers/tokenContext'

import FavoritesList from '../Favorites/FavoritesList'
import TrainingTypes from './TrainingTypes'
import Banner from './Banner'

import routeConfig from 'routeConfig'

const name = 'Nyeste treninger'

const Posts = ({
  match: {
    params: { after },
    url
  }
}) => {
  const { token } = useContext(TokenContext)
  const { data, loading } = useQuery(query, {
    variables: {
      first: 9,
      after
    }
  })
  const backState = { fromUrl: url, fromName: name }
  return (
    <PageWrapper title={name}>
      <Banner backState={backState} />
      {!after && <TrainingTypes />}
      {!after && token && <FavoritesList />}
      <PageTitle>{name}</PageTitle>
      {loading && !data && <LoadingSpinnerFullscreen />}
      {data && (
        <ListView
          {...data.posts}
          baseUrl={routeConfig.posts}
          after={after}
          backState={backState}
        />
      )}
    </PageWrapper>
  )
}

const query = gql`
  query Posts($first: Int!, $after: String) {
    posts(first: $first, after: $after) {
      ...PostList
    }
  }
  ${fragment}
`

export default Posts
